import { createContext, useContext } from 'react';

/** When set (e.g. 10001), body-portaled modals (ConfirmDialog) render above admin overlay. Only AdminDashboard provides this. */
export const AdminModalZContext = createContext<number | undefined>(undefined);

export function useAdminModalZIndex(): number | undefined {
  return useContext(AdminModalZContext);
}
